import React from 'react';
import { Aside as AsideStyled, AsideHeading } from './Aside.styles';
import CategoryFilter from 'components/CategoryFilter/CategoryFilter';
import { AsideProps } from 'models/AsideProps';
import { useIntl } from 'react-intl';

const Aside = ({ categoryList, activeFilters, keyword }: AsideProps) => {
  const { formatMessage } = useIntl();
  return (
    <AsideStyled>
      <AsideHeading as="div" $lookAlike="h3">
        <>{formatMessage({ id: 'CATEGORIES' })}</>
      </AsideHeading>
      <CategoryFilter
        categoryList={categoryList}
        activeFilters={activeFilters}
        keyword={keyword}
      />
    </AsideStyled>
  );
};

export default Aside;
